import script from "./StepPaymentMethod.vue?vue&type=script&setup=true&lang=js"
export * from "./StepPaymentMethod.vue?vue&type=script&setup=true&lang=js"

import "./StepPaymentMethod.vue?vue&type=style&index=0&id=13c3f636&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13c3f636"]])

export default __exports__